import { Box } from "@mui/material";
import { FILLED_TOGGLE_CONTROL_HEIGHT } from "@shared";

import { CounselorSelect } from "@/common/components/counselor-select/CounselorSelect";
import { useCurrentUserContext } from "@/common/contexts/current-user-context/CurrentUserContext";
import { ExchangeView } from "@/pages/exchange/Exchange.types";
import { useTranslation } from "@/translations";

import { ExchangeViewToggle } from "../view-toggle/ExchangeViewToggle";

interface Props {
  view: ExchangeView;
  onViewChange: (view: ExchangeView) => void;
  counselorId: string | null;
  onCounselorChange: (counselorId: string | null) => void;
}

/** View toggle plus the Berater:in filter, which only applies to the colleagues' requests. */
export function ExchangeFilterBar({ view, onViewChange, counselorId, onCounselorChange }: Props) {
  const { t } = useTranslation();
  const { currentUser } = useCurrentUserContext();

  return (
    <Box display="flex" alignItems="center" gap={3}>
      <ExchangeViewToggle value={view} onChange={onViewChange} />
      {view === "others" && (
        <CounselorSelect
          selectedCounselor={counselorId}
          onSelectCounselor={onCounselorChange}
          allOptionLabel={t("exchange.filter.allCounselors")}
          ariaLabel={t("exchange.filter.counselorAriaLabel")}
          minWidth={220}
          excludeCounselorId={currentUser.counselorId}
          height={FILLED_TOGGLE_CONTROL_HEIGHT}
        />
      )}
    </Box>
  );
}
